import React from 'react';
import {noop} from 'lodash';

import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {withCompetency, withTheme} from '/provider/ThemeProvider';
import {withHOC} from '/util/hoc.util';

import {styles} from './Pill.style';

interface PillProps {
  getTheme: (key: string) => any;
  children: string | React.ReactNode;
  onPress: () => void;
  style: {
    base: object;
    text: object;
    icon: object;
    push: (style: object) => void;
  };
}

const Pill: React.FC<PillProps> = ({
  getTheme = noop,
  children = null,
  onPress = noop,
  style = {base: {}, text: {}, icon: {}, push: () => {}},
}) => {
  const styleArray = [
    styles.base,
    getTheme('competency.backgroundColor'),
    style.base,
  ];

  return (
    <TouchableOpacity
      testID="pill-touchable"
      onPress={onPress}
      style={styleArray}>
      <Text variant="caption" style={{...styles.text, ...style.text}}>
        {children}
      </Text>
      <Icon
        name="close"
        style={{...styles.icon, ...style.icon}}
        testID="icon"
      />
    </TouchableOpacity>
  );
};

export default withHOC(withTheme, withCompetency)(Pill);
